import { useState, useCallback } from "react";
import { Auth } from "shared/@auth/Auth";
import regionConfig from "../../../../../../shared/regionConfig";

export const STATUS_READY = "STATUS_READY";
export const STATUS_GENERATING = "STATUS_GENERATING";

const newAPIBase = regionConfig.newAPIBase?.replace(/\/$/, "");

export function useGenerator(iboNumber, email) {
  const { makeAuthedRequest } = Auth.useContainer();

  const [status, setStatus] = useState(STATUS_READY);
  const [password, setPassword] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  const [otpStatus, setOtpStatus] = useState(STATUS_READY);
  const [otp, setOtp] = useState(null);
  const [otpError, setOtpError] = useState(null);

  const generate = useCallback(async () => {
    setStatus(STATUS_GENERATING);
    setPassword(null);
    setErrorMessage(null);

    return makeAuthedRequest("/v1/membership/password/generate", {
      method: "POST",
      body: JSON.stringify({ iboNumber }),
    })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          console.log(err);
          setErrorMessage(err.message);
        }
      })
      .then((password) => {
        setStatus(STATUS_READY);
        setPassword(password);
        return password;
      })
      .catch((err) => {
        console.error(err);
        setStatus(STATUS_READY);
      });
  }, [iboNumber, makeAuthedRequest]);

  const generateOtp = useCallback(async () => {
    setOtpStatus(STATUS_GENERATING);
    setOtp(null);
    setOtpError(null);

    const encodedEmail = encodeURIComponent(email);

    const url = `v1/core/auth/code?email=${encodedEmail}`;

    return makeAuthedRequest(url, {
      method: "GET",
    })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          console.log(err);
          setOtpError(err.message);
        }
      })
      .then((otp) => {
        setOtpStatus(STATUS_READY);
        setOtp(otp);
        return otp;
      })
      .catch((err) => {
        console.error(err);
        setOtpStatus(STATUS_READY);
      });
  }, [email, makeAuthedRequest]);

  return {
    status,
    password,
    errorMessage,
    generate,

    otpStatus,
    otp,
    otpError,
    generateOtp,
  };
}
